import React from "react";
import {
    ELECTRONIC_DOCUMENT_STATUS,
    INTERNAL_DOCUMENT_INCOMING_STATUS,
    MISSION_STATUS,
    NOTIFICATION_STATUS,
    POLICY_STATUS,
    PROPOSAL_STATUS,
    SALARY_STATUS,
    TYPE_STATUS,
    WORK_STATUS,
} from "../../utils/constants";

export const StatusTag = (typePage, status, isText = false) => {
    let text = "Không rõ";
    let style = null;

    if (typePage === TYPE_STATUS.ELECTRONIC_DOCUMENT) {
        if (status === ELECTRONIC_DOCUMENT_STATUS.PENDING) {
            style = "orange";
            text = "Chưa xử lý";
        }
        if (status === ELECTRONIC_DOCUMENT_STATUS.VT_APPROVAL) {
            style = "blue";
            text = "Văn thư đã duyệt";
        }
        if (status === ELECTRONIC_DOCUMENT_STATUS.LEAD_APPROVAL) {
            style = "geekblue";
            text = "Lãnh đạo đã duyệt";
        }
        if (status === ELECTRONIC_DOCUMENT_STATUS.REGIS_NUMBER) {
            style = "purple";
            text = "Đã cấp số";
        }
        if (status === ELECTRONIC_DOCUMENT_STATUS.READY) {
            style = "cyan";
            text = "Chờ phát hành";
        }
        if (status === ELECTRONIC_DOCUMENT_STATUS.RELEASE) {
            style = "green";
            text = "Đã phát hành";
        }
    }
    if (typePage === TYPE_STATUS.PROPOSAL) {
        if (status === PROPOSAL_STATUS.PENDING) {
            style = "orange";
            text = "Chờ phê duyệt";
        }
        if (status === PROPOSAL_STATUS.APPROVAL) {
            style = "green";
            text = "Đã phê duyệt";
        }
        if (status === PROPOSAL_STATUS.REJECT) {
            style = "red";
            text = "Từ chối";
        }
    }
    if (typePage === TYPE_STATUS.POLICY) {
        if (status === POLICY_STATUS.PENDING) {
            style = "blue";
            text = "Đang xử lý";
        }
        if (status === POLICY_STATUS.COMPLETE) {
            style = "green";
            text = "Hoàn thành";
        }
    }
    if (typePage === TYPE_STATUS.CONSULT) {
        if (status === POLICY_STATUS.PENDING) {
            style = "blue";
            text = "Đang cho ý kiến";
        }
        if (status === POLICY_STATUS.COMPLETE) {
            style = "green";
            text = "Hoàn thành";
        }
    }
    if (typePage === TYPE_STATUS.WORK) {
        if (status === WORK_STATUS.INTERNAL) {
            style = "cyan";
            text = "Nội bộ trong Ban";
        }
        if (status === WORK_STATUS.CONSULT) {
            style = "orange";
            text = "Xin ý kiến các Ban";
        }
        if (status === WORK_STATUS.POLICY) {
            style = "geekblue";
            text = "Xin chủ trương";
        }
        if (status === WORK_STATUS.DOCUMENT) {
            style = "blue";
            text = "Xử lý văn bản";
        }
        if (status === WORK_STATUS.ELECTRONIC) {
            style = "magenta";
            text = "Trình ký văn bản";
        }
        if (status === WORK_STATUS.DEPLOY) {
            style = "volcano";
            text = "Triển khai nhiệm vụ";
        }
        if (status === WORK_STATUS.OTHER) {
            style = "magenta";
            text = "Loại khác";
        }
        if (status === WORK_STATUS.COMPLETE) {
            style = "green";
            text = "Hoàn thành";
        }
        if (status === WORK_STATUS.PENDING) {
            style = "purple";
            text = "Đang thực hiện";
        }
    }
    if (typePage === TYPE_STATUS.NOTIFICATION) {
        if (status === NOTIFICATION_STATUS.OUTGOING) {
            style = "green";
            text = "Văn bản nội bộ đi";
        }
        if (status === NOTIFICATION_STATUS.INCOMING) {
            style = "green";
            text = "Văn bản nội bộ đến";
        }
        if (status === NOTIFICATION_STATUS.WORK) {
            style = "orange";
            text = "Công việc";
        }
        if (status === NOTIFICATION_STATUS.TASK) {
            style = "purple";
            text = "Nhiệm vụ";
        }
        if (
            [
                NOTIFICATION_STATUS.VEHICLE,
                NOTIFICATION_STATUS.LEAVE,
                NOTIFICATION_STATUS.LEAVE_ANNUAL,
                NOTIFICATION_STATUS.LEAVE_NO_SALARY,
                NOTIFICATION_STATUS.BUSINESS_TRIP,
                NOTIFICATION_STATUS.EVALUATE_MEMBER,
                NOTIFICATION_STATUS.EVALUATE_LEADER,
                NOTIFICATION_STATUS.TIMEKEEPER,
                NOTIFICATION_STATUS.STATIONERY,
                NOTIFICATION_STATUS.MEETING,
            ].includes(status)
        ) {
            style = "cyan";
            text = "Hành chính";
        }
        if ([NOTIFICATION_STATUS.PROPOSAL_SALARY].includes(status)) {
            style = "cyan";
            text = "Duyệt lương";
        }
        if (status === NOTIFICATION_STATUS.CONSULT) {
            style = "#597ef7";
            text = "Xin ý kiến";
        }
        if (status === NOTIFICATION_STATUS.POLICY) {
            style = "#69c0ff";
            text = "Xin chủ chương";
        }
        if (status === NOTIFICATION_STATUS.VBLT_DI) {
            style = "#69c0ff";
            text = "Văn bản liên thông đi";
        }
        if (status === NOTIFICATION_STATUS.VBLT_DEN) {
            style = "#69c0ff";
            text = "Văn bản liên thông đến";
        }
        if (status === NOTIFICATION_STATUS.WORK_SCHEDULE) {
            style = "#d03bff";
            text = "Lịch cơ quan";
        }
        if (status === NOTIFICATION_STATUS.GENERAL) {
            style = "blue";
            text = "Thông báo chung";
        }
        if (
            status === NOTIFICATION_STATUS.INTERNAL_MESSAGE_INCOMING ||
            status === NOTIFICATION_STATUS.INTERNAL_MESSAGE_OUTGOING ||
            status === NOTIFICATION_STATUS.INTERNAL_MESSAGE_INCOMING_REPLY ||
            status === NOTIFICATION_STATUS.INTERNAL_MESSAGE_OUTGOING_REPLY
        ) {
            style = "blue";
            text = "Tin nhắn";
        }
    }
    if (typePage === TYPE_STATUS.INTERNAL_DOCUMENT_INCOMING) {
        if (status === INTERNAL_DOCUMENT_INCOMING_STATUS.PENDING) {
            style = "bg-lightYellow border-yellow text-[#615207]";
            text = "Chờ xử lý";
        }
        if (status === INTERNAL_DOCUMENT_INCOMING_STATUS.INPROGRESS) {
            style = "bg-lightBlue border-primary text-[#161616]";
            text = "Đã bút phê";
        }
        if (status === INTERNAL_DOCUMENT_INCOMING_STATUS.COMPLETE) {
            style = "green";
            text = "Hoàn thành";
        }
    }
    if (typePage === TYPE_STATUS.MISSION) {
        if (status === MISSION_STATUS.PENDING) {
            style = "orange";
            text = "Chưa thực hiện";
        }
        if (status === MISSION_STATUS.INPROGRESS) {
            style = "blue";
            text = "Đang thực hiện";
        }
        if (status === MISSION_STATUS.COMPLETE) {
            style = "green";
            text = "Hoàn thành";
        }
    }

    if (typePage === TYPE_STATUS.SALARY) {
        if (status === SALARY_STATUS.PENDING) {
            style = "orange";
            text = "Chờ phê duyệt";
        }
        if (status === SALARY_STATUS.TRUONG_BAN_APPROVED) {
            style = "blue";
            text = "Trưởng ban đã duyệt";
        }
        if (status === SALARY_STATUS.TGD_APPROVED) {
            style = "green";
            text = "Tổng giám đốc đã duyệt";
        }
    }

    if (isText) {
        return text;
    }

    return (
        <span style={{ display: "flex", alignItems: "center" }}>
            {style && (
                <div
                    className={` border-[1px]  px-[10px] rounded  font-semibold text-[10px] leading-6 inline-block ${style}`}
                >
                    {text}
                </div>
            )}
        </span>
    );
};
